import { Link } from "react-router-dom";

import "./ArticleCard.css";

export default function ArticleCard({
    article,
}) {
    return (
        <article className="article-card">

            <Link
                to={`/articles/${article.slug}`}
                className="article-card__image-link"
            >

                {/* <img
                    className="article-card__image"
                    src={article.image}
                    alt={article.title}
                    loading="lazy"
                /> */}

                <img
    className="article-card__image"
    src={article.image || "/images/article-placeholder.jpg"}
    alt={article.title}
    loading="lazy"
/>

            </Link>


            <div className="article-card__body">

                {article.categories?.[0] && (
                    <span className="article-card__category">
                        {article.categories[0].title}
                    </span>
                )}


                <Link
                    to={`/articles/${article.slug}`}
                    className="article-card__title"
                >
                    {article.title}
                </Link>


                {article.excerpt && (
                    <p className="article-card__excerpt">
                        {article.excerpt}
                    </p>
                )}


                <div className="article-card__footer">

                    <span>
                        {formatVisits(
                            article.visited
                        )} بازدید
                    </span>

                    {article.publishedAt && (
                        <span>
                            {article.publishedAt}
                        </span>
                    )}

                </div>

            </div>

        </article>
    );
}


function formatVisits(value) {
    const number = Number(value || 0);

    if (number >= 1000000) {
        return `${(number / 1000000).toFixed(1)}M`;
    }

    if (number >= 1000) {
        return `${(number / 1000).toFixed(1)}K`;
    }

    return number.toLocaleString("fa-IR");
}